import { ACTION_BUTTON_MESSAGES, ActionButtonMessages } from "../action-buttons.messages";
import { SIDEBAR_MESSAGES, SidebarMessages } from "../layout/sidebar";

export type PlanMessages = ActionButtonMessages &
  SidebarMessages & {
    breadCrumbTitle: string;
    pageTitle: string;
    notFoundAlt: string;
    notFoundError: string;
    errorToLoad: string;
    salesProductErrorToLoad: string;
    salesProductNotFoundAlt: string;

    // Mensagens para planos não encontrados
    plansNotFoundError: string;
    plansNotFoundDescription: string;
    plansNotFoundAlt: string;

    planFeeCurrency: string;
    planFeeMonth: string;

    // Button messages
    buyNowButton: string;
    contractedButton: string;

    // Success Messages
    planCreateSuccess: string;
    planDeleteSuccess: string;

    // Error Messages
    planCreateError: string;
    planDeleteError: string;
    planAlreadyActiveError: string;
    permissionErrorMessage: string;

    // Format Messages
    feePerOrderText: string;
    feePerConversationText: string;
  };

export const PLAN_MESSAGES: PlanMessages = {
  breadCrumbTitle: "Contrate Agora",
  pageTitle: "Contrate Agora",
  notFoundAlt: "Plano não encontrado",
  notFoundError: "Erro ao carregar o plano",
  errorToLoad: "Erro ao carregar o plano. Por favor, tente novamente mais tarde.",
  salesProductErrorToLoad: "Erro ao carregar o produto de venda. Tente novamente mais tarde.",
  salesProductNotFoundAlt: "Produto de venda não encontrado",

  // Mensagens para planos não encontrados
  plansNotFoundError: "Plano não encontrado",
  plansNotFoundDescription:
    "Nenhum plano disponível no momento. Por favor, tente novamente mais tarde.",
  plansNotFoundAlt: "Nenhum plano encontrado",

  planFeeCurrency: "R$",
  planFeeMonth: "mês",

  // Button messages
  buyNowButton: "Contrate Agora!",
  contractedButton: "CONTRATADO",

  // Success Messages
  planCreateSuccess: "Plano contratado com sucesso",
  planDeleteSuccess: "Plano excluído com sucesso",

  // Error Messages
  planCreateError: "Erro ao contratar o plano",
  planDeleteError: "Erro ao excluir o plano",
  planAlreadyActiveError: "Este plano já foi adicionado e está ativo.",
  permissionErrorMessage:
    "Você não tem permissão para assinar planos. Somente administradores e gerentes podem realizar essa ação.",

  // Format Messages
  feePerOrderText: "por pedido",
  feePerConversationText: "por conversa",

  ...ACTION_BUTTON_MESSAGES,
  ...SIDEBAR_MESSAGES,
};

export default PLAN_MESSAGES;
